import state from "./moduleRentcarState.js";
import mutations from "./moduleRentcarMutations.js";
import actions from "./moduleRentcarActions.js";
import getters from "./moduleRentcarGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
